import { useQuery } from '@tanstack/react-query'
import { Programme, ProgrammeWorkout, SuggestedSeries, SuggestedSeriesSuggestionState } from 'src/dao/core-dao'
import { useProgrammeProgressCounts } from 'src/hook/use-programme-progress-counts'
import { coreService } from 'src/service/core-service'
import { queryKeys } from 'src/util/query-keys'
import { logger } from 'src/util/logger'

export interface UseSuggestedSeriesReturn {
  suggestionState: SuggestedSeriesSuggestionState | undefined
  suggestedSeries: Programme | undefined
  nextSeriesWorkout: ProgrammeWorkout | undefined
  completedClassesCount: number | undefined
  totalClassesCount: number | undefined
  isProgressReady: boolean
  isLoading: boolean
  isSuccess: boolean
  isFetching: boolean
}

export const useSuggestedSeries = (): UseSuggestedSeriesReturn => {
  const { data, isLoading, isSuccess, isFetching } = useQuery<SuggestedSeries | undefined, Error>(
    queryKeys.suggestedSeries(),
    () => coreService.getSuggestedSeries(),
    {
      onError: (error) => {
        logger.error('[SuggestedSeries] Failed to load suggested series', error)
      },
    },
  )

  const programmeId = data?.programme?.id ?? ''
  const { completedClassesCount, totalClassesCount, isProgressReady } = useProgrammeProgressCounts(programmeId)

  return {
    suggestionState: data?.suggestionState,
    suggestedSeries: data?.programme ?? undefined,
    nextSeriesWorkout: data?.nextProgrammeWorkout ?? undefined,
    completedClassesCount,
    totalClassesCount,
    isProgressReady,
    isLoading,
    isSuccess,
    isFetching,
  }
}
